
export default function Hero() {
  return (
    <section className="relative h-[85vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://static.readdy.ai/image/d59b18a86b2c4da172af70cd0d419253/d3888fb9f3d3b08e6cef7d5595e19eb2.png"
          alt="AI Automation Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center w-full">
        <div className="space-y-6">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2">
            <i className="ri-sparkling-line text-teal-400"></i>
            <span className="text-white text-sm font-medium">AI 기반 비즈니스 자동화 전문가</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight">
            AI로 비즈니스를<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-cyan-400">자동화</span>하세요
          </h1>

          <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto leading-relaxed">
            Freeworkers는 최첨단 AI 기술로 반복적인 업무를 자동화하고,<br />
            비즈니스 효율성을 극대화하는 맞춤형 솔루션을 제공합니다
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <a 
              href="#contact" 
              className="bg-teal-500 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-600 transition-all hover:scale-105 shadow-lg shadow-teal-500/30 whitespace-nowrap w-full sm:w-auto"
            >
              무료 상담 신청
            </a>
            <a 
              href="#services" 
              className="bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-lg text-base font-semibold hover:bg-white/20 transition-all whitespace-nowrap w-full sm:w-auto"
            >
              서비스 둘러보기
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-12 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-5">
              <div className="text-3xl font-bold text-teal-400 mb-2">500+</div>
              <div className="text-white text-sm">자동화 프로젝트 완료</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-5">
              <div className="text-3xl font-bold text-teal-400 mb-2">98%</div>
              <div className="text-white text-sm">고객 만족도</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-5">
              <div className="text-3xl font-bold text-teal-400 mb-2">70%</div>
              <div className="text-white text-sm">평균 업무 시간 절감</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
